export default __webpack_public_path__ + "static/media/diversifyproj.04cbb654.jpg";